import firebase from "firebase";
import axios from "axios";

const URL = "https://escuelapp-api-v2.azurewebsites.net/api/access";

async function headers() {
  const user = firebase.auth().currentUser;
  if (!user) throw new Error("Inicia sesión para configurar tu acceso.");
  return { Authorization: "Bearer " + await user.getIdToken(true) };
}

export async function getAccountAccess() {
  return (await axios.get(URL + "/me", { headers: await headers() })).data;
}

export async function loginWithUsername(username, password) {
  const result = await axios.post(URL + "/login", { username, password });
  return firebase.auth().signInWithCustomToken(result.data.token);
}

export function reauthenticationProvider(user, session) {
  const supported = ["google.com", "apple.com", "facebook.com"];
  if (supported.includes(session.signInProvider)) return session.signInProvider;
  const linked = (user.providerData || []).map(item => item.providerId);
  return supported.find(provider => linked.includes(provider)) || null;
}

export function hasRecentAuthentication(session, now = Date.now()) {
  const seconds = session.claims && session.claims.auth_time;
  const authenticatedAt = typeof seconds === "number" ? seconds * 1000 : Date.parse(session.authTime);
  const age = now - authenticatedAt;
  // The server requires ten minutes; leave one minute for request/clock differences.
  return Number.isFinite(age) && age >= -60000 && age < 9 * 60 * 1000;
}

export async function saveAccountAccess(username, password) {
  const user = firebase.auth().currentUser;
  if (!user) throw new Error("Inicia sesión para configurar tu acceso.");
  const session = await user.getIdTokenResult();
  if (!hasRecentAuthentication(session)) {
    const provider = reauthenticationProvider(user, session);
    if (provider) {
      const authProvider = provider === "google.com" ? new firebase.auth.GoogleAuthProvider()
        : provider === "apple.com" ? new firebase.auth.OAuthProvider("apple.com")
        : new firebase.auth.FacebookAuthProvider();
      await user.reauthenticateWithPopup(authProvider);
    } else {
      throw new Error("Tu sesión es antigua. Cierra sesión y vuelve a entrar antes de cambiar tus datos de acceso.");
    }
  }
  const result = await axios.put(URL + "/me", { username, password: password || null }, { headers: await headers() });
  // Admin password updates revoke older refresh tokens. Establish a fresh session.
  if (password) await firebase.auth().signInWithEmailAndPassword(user.email, password);
  return result.data;
}

export function accessError(error) {
  if (error.response && error.response.data && error.response.data.message) return error.response.data.message;
  if (error.code === "auth/wrong-password" || error.code === "auth/invalid-credential") return "No se ha podido verificar tu identidad. Vuelve a iniciar sesión.";
  if (error.code === "auth/popup-closed-by-user") return "Se ha cancelado la verificación. Vuelve a intentarlo.";
  if (error.code === "auth/popup-blocked") return "Permite las ventanas emergentes para confirmar tu identidad.";
  return error.message || "No se ha podido guardar el acceso. Inténtalo de nuevo.";
}



// WEBPACK FOOTER //
// ./app/accountAccess.js